/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap} from "gsap";
import {DevilsCrossRoadGameAssets} from "../../../DevilsCrossRoadGameAssets";
import {DevilsCrossRoadLayers, Layers} from "../../../view/DevilsCrossRoadLayers";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";

export class BigWinCountUp extends PIXI.Container {

    protected _countUp:BitmapCountUp;
    private _endingScale:number = 0.8;

    public set externalAlpha(value:number) {
        this._countUp.alpha = value;
    }

    public get externalAlpha():number {
        return this._countUp.alpha;
    }

    constructor() {
        super();

        const style = {
            fontName : DevilsCrossRoadGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 188,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUp.letterSpacing = -20;
        this.addChild(this._countUp);
        this.position.set(360, 600);
        DevilsCrossRoadLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from:number, to:number, duration:number,isLastLevel:boolean):TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ],0);
        if (!isLastLevel) {
            tl.to(this._countUp.scale, {
                duration: 0.91,
                x: 0.85,
                y: 0.85,
                ease: "power1.easeIn"
            }, duration - 0.9);
        }else{
            if(DevilsCrossRoad.model.gameData.brokeTheBank){
                tl.add(()=> {
                    DevilsCrossRoadSound.soundPlayer.playTrack({
                        name: DevilsCrossRoadSound.MAX_WIN_COUNTUP
                    });
                });
            }else {
                tl.add(() => {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.BIG_WIN_END});
                })
            }
        }
        return tl;
    }

    public stay():TimelineLite {
        const tl = gsap.timeline();
        tl.to(this.scale, {
            x: 1.2,
            y: 1.2,
            duration: 0.3,
            ease: "Power1.easeOut"
        });

        tl.to(this.scale, {
            x: 1,
            y: 1,
            duration: 0.5,
            ease: "Bounce.easeOut"
        });
        // timeline.add(() => ElPasoGunfightSoundConfig.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove():TimelineLite {
        const tl = gsap.timeline();
        if(this._countUp.visible) {
            tl.add(gsap.to(this._countUp, {duration : 0.5, alpha : 0, y : -100, ease : `power2.in`}), `+=0.2`); // stay a short while after count up.
            tl.add(() => { this.hideCountup()});
        }

        return tl;
    }

    public hideCountup():void{
        this._countUp.y = 0;
        this._countUp.visible = false;
    }
}